import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Pill from "../../../common/Pill";
import styles from "./status.module.scss";

export function Rejected() {
  const { t } = useTranslation();
  return (
    <Pill
      styleName="problemLight"
      Lefticon={<img src={"/assets/images/svg/errorStatus.svg"} />}>
      <p className={classNames(styles.text, "p2")}>
        {t("lbl_rejected_transaction")}
      </p>
    </Pill>
  );
}
